import { render, staticRenderFns } from "./CardScores.vue?vue&type=template&id=51a6d9c9&scoped=true&"
import script from "./CardScores.vue?vue&type=script&lang=js&"
export * from "./CardScores.vue?vue&type=script&lang=js&"
import style0 from "./CardScores.vue?vue&type=style&index=0&id=51a6d9c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a6d9c9",
  null
  
)

export default component.exports